export default __webpack_public_path__ + "static/4099929_md-33bf5237d2d5b7caad18170c820b01a3.jpg";